import React, { useState, useEffect, useRef } from "react";
import { Link, useParams } from "react-router-dom";
import { Editor } from "@tinymce/tinymce-react";
import { useNavigate } from "react-router-dom";
import api from "../api";
import { API_BASE_URL } from "../../config";
import axios from "axios";
import { toast } from "react-toastify";
import Loader from "../../Loader/loader";
import TableLoader from "../../Loader/TableLoader";

/** The bank fields the quotation prints, in the order it prints them. */
const BANK_FIELDS = [
  { key: "bank_name", label: "Bank name" },
  { key: "account_no", label: "Account no." },
  { key: "ifsc", label: "IFSC" },
  { key: "account_name", label: "Account name" },
  { key: "branch", label: "Branch", optional: true },
  { key: "upi", label: "UPI", optional: true },
];

const CompanyInformation = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [errors, setErrors] = useState({});
  const [edit, setEdit] = useState(false);

  const [imagePreview, setImagePreview] = useState(null);
  const [footerPreview, setFooterPreview] = useState(null);
  const [feviconPreview, setFeviconPreview] = useState(null);

  const [image, setImage] = useState();
  const [managePageData, setManagePageData] = useState();
  const [token, setToken] = useState(localStorage.getItem("cms_token"));
  /* What the quotation's bank card prints. Kept as fields here and stored as
     JSON in account_details. */
  const [bank, setBank] = useState({
    bank_name: "", account_no: "", ifsc: "", account_name: "", branch: "", upi: "",
  });
  /* True when the saved value was never structured — an older profile. */
  const [bankIsText, setBankIsText] = useState(false);

  const [formData, setFormData] = useState({
    company_name: "",
    website: "",
    mobile: "",
    mobile_sec: "",
    email: "",
    alternate_email: "",
    address: "",
    logo_title: "",
    facebook_link: "",
    twitter_link: "",
    linked_In_link: "",
    g_link: "",
    service_tax_no: "",
    cin_no: "",
    gst_no: "",
    sac_no: "",
    account_details: "",
    smtp_email_id: "",
    smtp_password: "",
    logo: "",
    short_description:"",
    id:"",
    footer_logo:"",
    fevicon_icon:"",
    schema_json:"",
    gtm_content:"",
    noscript_content:"",
    chatbot_url:"",
    android_store_url:"",
    ios_store_url:"",
  });

  const {
    company_name,
    website,
    mobile,
    mobile_sec,
    email,
    alternate_email,
    address,
    logo_title,
    facebook_link,
    twitter_link,
    linked_In_link,
    g_link,
    service_tax_no,
    cin_no,
    gst_no,
    sac_no,
    account_details,
    smtp_email_id,
    smtp_password,
    short_description,
    logo,
    id,
    footer_logo,
    fevicon_icon,
    schema_json,
    gtm_content,
    noscript_content,
    chatbot_url,
    android_store_url,
    ios_store_url
  } = formData;

  const validateForm = () => {
    let errors = {};
    // check for empty values

    if (!formData.company_name) {
      errors.company_name = " Company Name is required";
    }
    if (!formData.website) {
      errors.website = "Website name is required";
    }
    if (!formData.mobile) {
      errors.mobile = "phone no is required";
    }

    return errors;
  };



  const navigate = useNavigate();


  let hasError = false;

  useEffect(() => {
    setToken(localStorage.getItem("cms_token"));
    ViewCompanyProfile();
  }, []);

  const handleEditorChangeDescription = (content, editor) => {
    setFormData({ ...formData, description: content });
  };

  const ViewCompanyProfile = async () => {
    setIsLoading(true)
    const res = await axios.get(`${API_BASE_URL}/get-company-profile`, {
      headers: {
        Authorization: `Bearer ${token}`,
      }, 
    });
    // console.log(res, "res");
    if (res.data.status == 200) {
      setFormData({
        ...formData,
        company_name: res?.data.data.company_name,
        website: res?.data.data.website,
        mobile: res?.data.data.mobile,
        mobile_sec: res?.data.data.mobile_sec,
        email: res?.data.data.email,
        alternate_email: res?.data.data.alternate_email,
        address: res?.data.data.address,
        logo_title: res?.data.data.logo_title,
        facebook_link: res?.data.data.facebook_link,
        twitter_link: res?.data.data.twitter_link,
        linked_In_link: res?.data.data.linked_In_link,
        g_link: res?.data.data.g_link,
        service_tax_no: res?.data.data.service_tax_no,
        cin_no: res?.data.data.cin_no,
        gst_no: res?.data.data.gst_no,
        sac_no: res?.data.data.sac_no,
        account_details: res?.data.data.account_details,
        smtp_email_id: res?.data.data.smtp_email_id,
        smtp_password: res?.data.data.smtp_password,
        short_description:res?.data.data.short_description,
        logo: res?.data.data.logo,
        footer_logo: res?.data.data.footer_logo,
        fevicon_icon: res?.data.data.favicon_icon,
        id:res?.data.data.id,
        schema_json:res?.data.data.schema_json,
        gtm_content:res?.data.data.gtm_content,
        noscript_content:res?.data.data.noscript_content,
        chatbot_url:res?.data.data.chatbot_url,
        /* A never-filled column comes back null, which React reads as an
           uncontrolled input — hence the empty-string floor. */
        android_store_url:res?.data.data.android_store_url || "",
        ios_store_url:res?.data.data.ios_store_url || ""
      });
      /* account_details holds JSON once the bank fields have been saved; an
         older profile still has plain text, and that keeps its own input. */
      const saved = res?.data.data.account_details;
      try {
        const parsed = JSON.parse(saved);
        if (parsed && typeof parsed === "object" && !Array.isArray(parsed)) {
          setBank((prev) => ({ ...prev, ...parsed }));
          setBankIsText(false);
        } else {
          setBankIsText(Boolean(saved));
        }
      } catch {
        setBankIsText(Boolean(saved));
      }
      setImagePreview(res?.data.data.logo);
      setFooterPreview(res?.data.data.footer_logo);
      setFeviconPreview(res?.data.data.favicon_icon);
      setIsLoading(false)
    }
    else{
      setIsLoading(false)
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const errors = validateForm();
    // console.log(formData, "form");
    // console.log(errors, "err");


    if (Object.keys(errors).length === 0) {
      
  const formData = new FormData();
    formData.append("company_name", company_name);
    formData.append("website", website);
    formData.append("mobile", mobile);
    formData.append("mobile_sec", mobile_sec);
    formData.append("email", email);
    formData.append("alternate_email", alternate_email);
    formData.append("address", address);
    formData.append("logo_title", logo_title);
    formData.append("twitter_link", twitter_link);
    formData.append("linked_In_link", linked_In_link);
    formData.append("gpluse_link", g_link);
    formData.append("service_tax_no", service_tax_no);
    formData.append("cin_no", cin_no);
    formData.append("gst_no", gst_no);
    formData.append("sac_no", sac_no);
    /* Structured details win; the legacy text is only sent back when nothing was
       ever filled in, so an old profile is not wiped by opening the page. */
    const hasBank = BANK_FIELDS.some(({ key }) => String(bank[key] || "").trim());
    formData.append("account_detail", hasBank ? JSON.stringify(bank) : account_details);
    formData.append("smtp_email_id", smtp_email_id);
    formData.append("smtp_password", smtp_password);
    formData.append("short_description", short_description);
    formData.append("footer_logo", footer_logo);
    formData.append("fevicon_icon", fevicon_icon);
    formData.append("logo", logo);
    formData.append("id", id);
    formData.append("schema_json", schema_json);
    formData.append("gtm_content", gtm_content);
    formData.append("noscript_content", noscript_content);
    formData.append("chatbot_url", chatbot_url);
    formData.append("android_store_url", android_store_url);
    formData.append("ios_store_url", ios_store_url);
    // console.log(formData, "formdata");

      axios
        .post(`${API_BASE_URL}/update-company-profile`, formData, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((response) => {
          // console.log(response.data.status);
          if (response.data.status === 200) {
            navigate("/cms/companyinformation");
            toast.success("Updated successfully");     
          } 
        })                                                                                                                                    
        .catch((error) => {
          setErrors(error.response.data.result);
          console.log(error);
        });
    } else {
      setErrors(errors);
      // console.log(errors);
    }
  };

  const handleImageChange = (e) => {
    const selectedImage = e.target.files[0];
    if (!selectedImage) {
      setImagePreview(null);
      return;
    }
    const objectUrl = URL.createObjectURL(selectedImage);
    setImagePreview(objectUrl);
  };

  const handleFooterChange = (e) => {
    const selectedImage = e.target.files[0];
    if (!selectedImage) {
      setFooterPreview(null);
      return;
    }
    const objectUrl = URL.createObjectURL(selectedImage);
    setFooterPreview(objectUrl);
  };

  const handleFeviconChange = (e) => {
    const selectedImage = e.target.files[0];
    // console.log(e.target.files[0],"e.target.files[0]")
    if (!selectedImage) {
      setFeviconPreview(null);
      return;
    }
    const objectUrl = URL.createObjectURL(selectedImage);
    setFeviconPreview(objectUrl);
  };


  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData({ ...formData, [name]: value });
    setErrors({ ...errors, [name]: "" });
    if (name === "logo") {
      // console.log(event.target.files[0],"value")
      setFormData({ ...formData, [name]: event.target.files[0] });
      const selectedImage = event.target.files[0];
      if (!selectedImage) {
        setImagePreview(null);
        return;
      }
      const objectUrl = URL.createObjectURL(selectedImage);
      setImagePreview(objectUrl);
    }
    if (name === "footer_logo") {
      // console.log(event.target.files[0],"footer_logo")
      setFormData({ ...formData, [name]: event.target.files[0] });
      const selectedImage = event.target.files[0];
      if (!selectedImage) {
        setFooterPreview(null);
        return;
      }
      const objectUrl = URL.createObjectURL(selectedImage);
      setFooterPreview(objectUrl);
    }
    if (name === "fevicon_icon") {

      // console.log(event.target.files[0],"favicon")
      setFormData({ ...formData, [name]: event.target.files[0] });
      const selectedImage = event.target.files[0];
      if (!selectedImage) {
        setFeviconPreview(null);
        return;
      }
      const objectUrl = URL.createObjectURL(selectedImage);
      setFeviconPreview(objectUrl);
    }
  };

  
  const iStyle = (hasError) => ({
    width: "100%", padding: "9px 13px", border: `1px solid ${hasError ? "#ef4444" : "#e2e8f0"}`,
    borderRadius: 8, fontSize: 14, color: "#1e293b", background: edit ? "#fff" : "#f8fafc",
    outline: "none", cursor: edit ? "text" : "not-allowed",
  });

  const labelStyle = { display: "block", fontSize: 12, fontWeight: 600, color: "#64748b", marginBottom: 6, textTransform: "uppercase", letterSpacing: 0.4 };

  const sectionCard = { background: "#fff", borderRadius: 12, border: "1px solid #e2e8f0", padding: "24px 28px", marginBottom: 24, boxShadow: "0 1px 4px rgba(0,0,0,0.05)" };

  const sectionTitle = (icon, text, color) => (
    <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 20, paddingBottom: 12, borderBottom: "2px solid #f1f5f9" }}>
      <div style={{ width: 32, height: 32, borderRadius: 8, background: `${color}15`, display: "flex", alignItems: "center", justifyContent: "center" }}>
        <i className={icon} style={{ color, fontSize: 14 }} />
      </div>
      <span style={{ fontWeight: 700, fontSize: 15, color: "#1e293b" }}>{text}</span>
    </div>
  );

  const imgPreviewBox = (preview, label) => preview ? (
    <div style={{ marginTop: 10, padding: 10, border: "1px dashed #e2e8f0", borderRadius: 8, display: "inline-block", background: "#fafbff" }}>
      <img src={preview} alt={label} style={{ width: 100, height: 100, objectFit: "contain", borderRadius: 6 }} />
      <div style={{ fontSize: 11, color: "#94a3b8", textAlign: "center", marginTop: 4 }}>{label}</div>
    </div>
  ) : null;

  return (
    <>
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">

            {/* Page Header */}
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 24 }}>
              <div>
                <h4 style={{ margin: 0, fontSize: 22, fontWeight: 700, color: "#1e293b" }}>Company Information</h4>
                <div style={{ display: "flex", alignItems: "center", gap: 6, marginTop: 4 }}>
                  <span style={{ fontSize: 12, color: "#94a3b8" }}>CMS</span>
                  <span style={{ color: "#cbd5e1", fontSize: 12 }}>/</span>
                  <Link to={"/cms/managecompanyprofile"} style={{ fontSize: 12, color: "#94a3b8", textDecoration: "none" }}>Company Information</Link>
                  <span style={{ color: "#cbd5e1", fontSize: 12 }}>/</span>
                  <span style={{ fontSize: 12, color: "#4f46e5", fontWeight: 600 }}>Settings</span>
                </div>
              </div>
              {!edit && (
                <button onClick={() => setEdit(true)} style={{ display: "inline-flex", alignItems: "center", gap: 7, background: "linear-gradient(135deg,#4f46e5,#7c3aed)", color: "#fff", border: "none", borderRadius: 10, padding: "9px 20px", fontWeight: 600, fontSize: 14, cursor: "pointer", boxShadow: "0 4px 12px rgba(79,70,229,0.3)" }}>
                  <i className="fa fa-edit" /> Edit Information
                </button>
              )}
            </div>

            <form onSubmit={handleSubmit}>
              {isLoading ? (
                <div style={sectionCard}>
                  <table className="table align-middle table-nowrap mb-0"><tbody><TableLoader count={1} /></tbody></table>
                </div>
              ) : (
                <>
                  {/* Section 1 — Basic Information */}
                  <div style={sectionCard}>
                    {sectionTitle("fa fa-building", "Basic Information", "#4f46e5")}
                    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "0 32px" }}>
                      <div style={{ marginBottom: 20 }}>
                        <label style={labelStyle}>Company Name</label>
                        <input id="company_name" name="company_name" type="text" value={company_name} style={iStyle(errors?.company_name)} placeholder="Enter Company Name" onChange={handleInputChange} disabled={!edit} />
                        {errors?.company_name && <div style={{ color: "#ef4444", fontSize: 12, marginTop: 4 }}>{errors.company_name}</div>}
                      </div>
                      <div style={{ marginBottom: 20 }}>
                        <label style={labelStyle}>Website</label>
                        <input id="website" name="website" type="text" value={website} style={iStyle(errors?.website)} placeholder="Enter Website URL" onChange={handleInputChange} disabled={!edit} />
                        {errors?.website && <div style={{ color: "#ef4444", fontSize: 12, marginTop: 4 }}>{errors.website}</div>}
                      </div>
                      <div style={{ marginBottom: 20 }}>
                        <label style={labelStyle}>Logo Title</label>
                        <input id="logo_title" name="logo_title" type="text" value={logo_title} style={iStyle(false)} placeholder="Enter Logo Title" onChange={handleInputChange} disabled={!edit} />
                      </div>
                      <div style={{ marginBottom: 20 }}>
                        <label style={labelStyle}>Short Description</label>
                        <input id="short_description" name="short_description" type="text" value={short_description} style={iStyle(false)} placeholder="Enter Short Description" onChange={handleInputChange} disabled={!edit} />
                      </div>
                      <div style={{ marginBottom: 20, gridColumn: "1 / -1" }}>
                        <label style={labelStyle}>India Address</label>
                        <input id="india_address" name="address" type="text" value={address} style={iStyle(false)} placeholder="Enter India Address" onChange={handleInputChange} disabled={!edit} />
                      </div>
                    </div>
                  </div>

                  {/* Section 2 — Contact Details */}
                  <div style={sectionCard}>
                    {sectionTitle("fa fa-phone", "Contact Details", "#0891b2")}
                    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "0 32px" }}>
                      <div style={{ marginBottom: 20 }}>
                        <label style={labelStyle}>Phone Number</label>
                        <input id="phone_number" name="mobile" type="text" value={mobile} style={iStyle(false)} placeholder="Enter Phone Number" onChange={handleInputChange} disabled={!edit} />
                      </div>
                      <div style={{ marginBottom: 20 }}>
                        <label style={labelStyle}>Alternate Number</label>
                        <input id="alternate_number" name="mobile_sec" type="text" value={mobile_sec} style={iStyle(false)} placeholder="Enter Alternate Number" onChange={handleInputChange} disabled={!edit} />
                      </div>
                      <div style={{ marginBottom: 20 }}>
                        <label style={labelStyle}>Email Address</label>
                        <input id="email_address" name="email" type="text" value={email} style={iStyle(false)} placeholder="Enter Email Address" onChange={handleInputChange} disabled={!edit} />
                      </div>
                      <div style={{ marginBottom: 20 }}>
                        <label style={labelStyle}>Alternate Email</label>
                        <input id="alternate_email" name="alternate_email" type="text" value={alternate_email} style={iStyle(false)} placeholder="Enter Alternate Email" onChange={handleInputChange} disabled={!edit} />
                      </div>
                    </div>
                  </div>

                  {/* Section 3 — Social Media */}
                  <div style={sectionCard}>
                    {sectionTitle("fa fa-share-alt", "Social Media Links", "#16a34a")}
                    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "0 32px" }}>
                      <div style={{ marginBottom: 20 }}>
                        <label style={labelStyle}><i className="fa fa-facebook" style={{ marginRight: 5, color: "#1877f2" }} />Facebook</label>
                        <input id="facebook_link" name="facebook_link" type="text" value={facebook_link} style={iStyle(false)} placeholder="Enter Facebook URL" onChange={handleInputChange} disabled={!edit} />
                      </div>
                      <div style={{ marginBottom: 20 }}>
                        <label style={labelStyle}><i className="fa fa-twitter" style={{ marginRight: 5, color: "#1da1f2" }} />Twitter</label>
                        <input id="twitter_link" name="twitter_link" type="text" value={twitter_link} style={iStyle(false)} placeholder="Enter Twitter URL" onChange={handleInputChange} disabled={!edit} />
                      </div>
                      <div style={{ marginBottom: 20 }}>
                        <label style={labelStyle}><i className="fa fa-linkedin" style={{ marginRight: 5, color: "#0077b5" }} />LinkedIn</label>
                        <input id="linkedin_link" name="linked_In_link" type="text" value={linked_In_link} style={iStyle(false)} placeholder="Enter LinkedIn URL" onChange={handleInputChange} disabled={!edit} />
                      </div>
                      <div style={{ marginBottom: 20 }}>
                        <label style={labelStyle}><i className="fa fa-google" style={{ marginRight: 5, color: "#ea4335" }} />G+ Link</label>
                        <input id="g_link" name="g_link" type="text" value={g_link} style={iStyle(false)} placeholder="Enter G+ URL" onChange={handleInputChange} disabled={!edit} />
                      </div>
                    </div>
                  </div>

                  {/* Section 3b — App Store Links */}
                  <div style={sectionCard}>
                    {sectionTitle("fa fa-mobile", "Mobile App Links", "#0f766e")}
                    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "0 32px" }}>
                      <div style={{ marginBottom: 20 }}>
                        <label style={labelStyle}><i className="fa fa-android" style={{ marginRight: 5, color: "#3ddc84" }} />Android App Link</label>
                        <input id="android_store_url" name="android_store_url" type="text" value={android_store_url} style={iStyle(false)} placeholder="https://play.google.com/store/apps/details?id=..." onChange={handleInputChange} disabled={!edit} />
                      </div>
                      <div style={{ marginBottom: 20 }}>
                        <label style={labelStyle}><i className="fa fa-apple" style={{ marginRight: 5, color: "#111827" }} />iOS App Link</label>
                        <input id="ios_store_url" name="ios_store_url" type="text" value={ios_store_url} style={iStyle(false)} placeholder="https://apps.apple.com/in/app/..." onChange={handleInputChange} disabled={!edit} />
                      </div>
                    </div>
                  </div>

                  {/* Section 4 — Tax & Legal */}
                  <div style={sectionCard}>
                    {sectionTitle("fa fa-file-text", "Tax & Legal", "#d97706")}
                    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "0 32px" }}>
                      <div style={{ marginBottom: 20 }}>
                        <label style={labelStyle}>Service Tax No.</label>
                        <input id="service_tax_no" name="service_tax_no" type="text" value={service_tax_no} style={iStyle(false)} placeholder="Enter Service Tax No." onChange={handleInputChange} disabled={!edit} />
                      </div>
                      <div style={{ marginBottom: 20 }}>
                        <label style={labelStyle}>CIN No.</label>
                        <input id="cin_no" name="cin_no" type="text" value={cin_no} style={iStyle(false)} placeholder="Enter CIN No." onChange={handleInputChange} disabled={!edit} />
                      </div>
                      <div style={{ marginBottom: 20 }}>
                        <label style={labelStyle}>GST No.</label>
                        <input id="gst_no" name="gst_no" type="text" value={gst_no} style={iStyle(false)} placeholder="Enter GST No." onChange={handleInputChange} disabled={!edit} />
                      </div>
                      <div style={{ marginBottom: 20 }}>
                        <label style={labelStyle}>SAC No.</label>
                        <input id="sac_no" name="sac_no" type="text" value={sac_no} style={iStyle(false)} placeholder="Enter SAC No." onChange={handleInputChange} disabled={!edit} />
                      </div>
                      {/* Bank details are stored as JSON in account_details, so the
                          quotation can lay them out in its own four-cell card. The
                          admin edits fields, never the JSON. */}
                      <div style={{ gridColumn: "1 / -1" }}>
                        <label style={{ ...labelStyle, marginBottom: 12, display: "block" }}>Bank / A/C Details</label>
                        {bankIsText ? (
                          <>
                            <input
                              id="account_details" name="account_details" type="text"
                              value={account_details} style={iStyle(false)}
                              placeholder="Enter Account Details" onChange={handleInputChange} disabled={!edit}
                            />
                            <div style={{ fontSize: 12, color: "#b45309", marginTop: 6 }}>
                              These details were saved as plain text. Fill the fields below instead and
                              save — the quotation can only lay out structured details.
                            </div>
                          </>
                        ) : null}
                        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(220px,1fr))", gap: 16, marginTop: bankIsText ? 16 : 0 }}>
                          {BANK_FIELDS.map(({ key, label: bankLabel, optional }) => (
                            <div key={key}>
                              <label style={labelStyle}>
                                {bankLabel}
                                {optional && <span style={{ color: "#9ca3af", fontWeight: 400 }}> (optional)</span>}
                              </label>
                              <input
                                type="text"
                                value={bank[key] || ""}
                                style={iStyle(false)}
                                placeholder={`Enter ${bankLabel}`}
                                onChange={(e) => setBank((prev) => ({ ...prev, [key]: e.target.value }))}
                                disabled={!edit}
                              />
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Section 5 — SMTP Configuration */}
                  <div style={sectionCard}>
                    {sectionTitle("fa fa-envelope", "SMTP Configuration", "#7c3aed")}
                    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "0 32px" }}>
                      <div style={{ marginBottom: 20 }}>
                        <label style={labelStyle}>SMTP Email ID</label>
                        <input id="smtp_email_id" name="smtp_email_id" type="text" value={smtp_email_id} style={iStyle(false)} placeholder="Enter SMTP Email ID" onChange={handleInputChange} disabled={!edit} />
                      </div>
                      <div style={{ marginBottom: 20 }}>
                        <label style={labelStyle}>SMTP Password</label>
                        <input id="smtp_password" name="smtp_password" type="text" value={smtp_password} style={iStyle(false)} placeholder="Enter SMTP Password" onChange={handleInputChange} disabled={!edit} />
                      </div>
                    </div>
                  </div>

                  {/* Section 6 — Branding & Assets */}
                  <div style={sectionCard}>
                    {sectionTitle("fa fa-image", "Branding & Assets", "#0891b2")}
                    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: "0 32px" }}>
                      <div style={{ marginBottom: 20 }}>
                        <label style={labelStyle}>Header Logo</label>
                        <input className={errors?.logo ? "form-control is-invalid" : "form-control"} name="logo" type="file" accept="image/*" disabled={!edit} onChange={(e) => { handleImageChange(e); handleInputChange(e); }} />
                        {imgPreviewBox(imagePreview, "Logo Preview")}
                      </div>
                      <div style={{ marginBottom: 20 }}>
                        <label style={labelStyle}>Footer Logo</label>
                        <input className={errors?.footer_logo ? "form-control is-invalid" : "form-control"} name="footer_logo" type="file" accept="image/*" disabled={!edit} onChange={(e) => { handleFooterChange(e); handleInputChange(e); }} />
                        {imgPreviewBox(footerPreview, "Footer Preview")}
                      </div>
                      <div style={{ marginBottom: 20 }}>
                        <label style={labelStyle}>Favicon</label>
                        <input className={errors?.fevicon_icon ? "form-control is-invalid" : "form-control"} name="fevicon_icon" type="file" accept="image/*" disabled={!edit} onChange={(e) => { handleFeviconChange(e); handleInputChange(e); }} />
                        {imgPreviewBox(feviconPreview, "Favicon Preview")}
                      </div>
                    </div>
                  </div>

                  {/* Section 7 — Technical / SEO */}
                  <div style={sectionCard}>
                    {sectionTitle("fa fa-code", "Technical & SEO", "#dc2626")}
                    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "0 32px" }}>
                      <div style={{ marginBottom: 20 }}>
                        <label style={labelStyle}>Schema JSON</label>
                        <textarea id="schema_json" name="schema_json" value={schema_json} style={{ ...iStyle(false), resize: "vertical" }} placeholder="Enter Schema JSON" onChange={handleInputChange} disabled={!edit} rows={5} />
                      </div>
                      <div style={{ marginBottom: 20 }}>
                        <label style={labelStyle}>GTM Script</label>
                        <textarea id="gtm_content" name="gtm_content" value={gtm_content} style={{ ...iStyle(false), resize: "vertical" }} placeholder="Enter GTM Script" onChange={handleInputChange} disabled={!edit} rows={5} />
                      </div>
                      <div style={{ marginBottom: 20 }}>
                        <label style={labelStyle}>NoScript Content</label>
                        <textarea id="noscript_content" name="noscript_content" value={noscript_content} style={{ ...iStyle(false), resize: "vertical" }} placeholder="Enter NoScript Content" onChange={handleInputChange} disabled={!edit} rows={5} />
                      </div>
                      <div style={{ marginBottom: 20 }}>
                        <label style={labelStyle}>Chatbot URL</label>
                        <input id="chatbot_url" name="chatbot_url" type="text" value={chatbot_url} style={iStyle(false)} placeholder="Enter Chatbot URL" onChange={handleInputChange} disabled={!edit} />
                      </div>
                    </div>
                  </div>

                  {/* Save Bar */}
                  {edit && (
                    <div style={{ position: "sticky", bottom: 0, background: "#fff", borderTop: "1px solid #e2e8f0", padding: "16px 28px", display: "flex", justifyContent: "flex-end", gap: 12, boxShadow: "0 -4px 16px rgba(0,0,0,0.06)", borderRadius: "12px 12px 0 0", zIndex: 10 }}>
                      <button type="button" onClick={() => setEdit(false)} style={{ padding: "9px 22px", background: "#f1f5f9", color: "#64748b", border: "1px solid #e2e8f0", borderRadius: 9, fontWeight: 600, fontSize: 14, cursor: "pointer" }}>
                        Cancel
                      </button>
                      <button type="submit" style={{ padding: "9px 28px", background: "linear-gradient(135deg,#4f46e5,#7c3aed)", color: "#fff", border: "none", borderRadius: 9, fontWeight: 600, fontSize: 14, cursor: "pointer", boxShadow: "0 4px 12px rgba(79,70,229,0.3)" }}>
                        <i className="fa fa-save" style={{ marginRight: 7 }} /> Update Information
                      </button>
                    </div>
                  )}
                </>
              )}
            </form>

          </div>
        </div>
      </div>
    </>
  );
};

export default CompanyInformation;
